import React, { useEffect, useState, useRef } from "react";
import { useParams } from 'react-router-dom';
import CustomHeader from "../../components/header/index.jsx";
import './migrationnew.scss';
import { Container, Col, Row } from 'react-bootstrap';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useNavigate } from 'react-router-dom';
import url from "../../config.js"
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Settings, ArrowRight, Info, AlertTriangle, CheckCircle, Zap, Database,
  Cloud, Cpu, Upload, FileText, Folder, X, Eye, Download, Terminal, Rocket
} from 'lucide-react';
import socketIOClient from "socket.io-client";
import ConsolePromptPanel from '../../components/consolePromptPanel';


const domain = url.domain;
const backendUrl = url.backendUrl;
const socketUrl = url.SOCKET;




function Migration({ onConfigChange, initialConfig = {} }) {
  let { projId, projName } = useParams();
  const filesRef = useRef([]);
  const fileInputRef = useRef(null);
  const logEndRef = useRef(null);

  const [selectedRepoType, setSelectedRepoType] = useState('');
  const [selectedRepoAccount, setSelectedRepoAccount] = useState('');
  const [selectedDevOpsType, setSelectedDevOpsType] = useState('');
  const [selectedDevOpsAccount, setSelectedDevOpsAccount] = useState('');
  const [selectedCloudHubAccount, setSelectedCloudHubAccount] = useState('');
  const [selectedEnvironment, setSelectedEnvironment] = useState('');
  const [selectedEnvironmentId, setSelectedEnvironmentId] = useState('');
  const [environments, setEnvironments] = useState([]);
  const [loadingEnvironments, setLoadingEnvironments] = useState(false);
  const [environmentError, setEnvironmentError] = useState('');
  const [isDeploying, setIsDeploying] = useState(false);

  // Store selected account configs for deploy payload
  const [selectedRepoConfig, setSelectedRepoConfig] = useState({});
  const [selectedDevOpsConfig, setSelectedDevOpsConfig] = useState({});
  const [selectedMuleConfig, setSelectedMuleConfig] = useState({});
  const [config, setConfig] = useState({
    sourceType: 'jitterbit',
    targetType: 'mule',
    migrationStrategy: 'standard', // Hardcoded
    outputFormat: 'xml',
    optimizations: {
      removeUnusedComponents: true,
      optimizeFlows: false,
      generateDocumentation: true,
      validateConnectors: true
    },
    advanced: {
      parallelProcessing: false,
      maxRetries: 3,
      customTemplates: false,
      preserveComments: true
    },
    ...initialConfig
  });

  const navigate = useNavigate();
  const [migrationId, setMigrationId] = useState(null);
  const [ramlFilePath, setRamlFilePath] = useState(null);

  const [currentStep, setCurrentStep] = useState('upload');
  const socketRef = useRef(null);
  const logContainerRef = useRef(null);
  const [sessionId, setSessionId] = useState(null);

  const [state, setState] = useState({
    loading: false,
    fileUploaded: false,
    fileSelected: false,
    fileName: '',
    source: 'Jitterbit',
    tableData: {},
    extractedFiles: [],
    uploadedFiles: [],
    migrationInProgress: false,
    migrationResults: null,
    progress: 0,
    migrationId: null,
    migrationProgress: {
      percentage: 0,
      current: 0,
      total: 0,
      status: 'idle',
      results: [],
      errors: []
    },
    pollInterval: null,
    migrationStatus: null,
    logs: [],
    socketConnected: false
  });



  // Migration type configurations
  const migrationTypes = {
    source: {
      jitterbit: {
        name: 'Jitterbit',
        description: 'Jitterbit Integration Studio projects and transformations',
        icon: <Database className="migration-card-icon" />,
        color: 'text-blue-400',
        fileTypes: ['.jb', '.xml', '.json', '.properties', '.zip'],
        complexity: 'Medium',
        estimatedTime: '2-4 hours per project',
        commonIssues: ['Custom scripts', 'Database connections', 'File operations']
      },
      oraclesoa: {
        name: 'Oracle SOA Suite',
        description: 'BPEL processes, composites, and SOA components',
        icon: <Cpu className="migration-card-icon" />,
        color: 'text-orange-400',
        fileTypes: ['.bpel', '.xml', '.wsdl', '.xsd', '.composite', '.zip'],
        complexity: 'High',
        estimatedTime: '4-8 hours per composite',
        commonIssues: ['Complex BPEL flows', 'Human workflows', 'Adapters']
      },
      boomi: {
        name: 'Dell Boomi',
        description: 'Boomi integration processes, connectors, and maps',
        icon: <Cloud className="migration-card-icon" />,
        color: 'text-green-400',
        fileTypes: ['.xml', '.json', '.zip', '.bpxml', '.component'],
        complexity: 'Medium-High',
        estimatedTime: '3-6 hours per process',
        commonIssues: ['Process shapes', 'Map transformations', 'Connector configurations']
      }
    },
    target: {
      mule: {
        name: 'MuleSoft Anypoint',
        description: 'Mule 4 applications with modern connectors',
        icon: <Zap className="migration-card-icon" />,
        color: 'text-purple-400',
        outputFormats: ['xml', 'json-config'],
        features: ['DataWeave 2.0', 'Anypoint Connectors', 'API-led architecture'],
        version: '4.x'
      }
    }
  };
  const getResource = async (endpoint, stateKey) => {
    try {
      const response = await fetch(`${domain}/api/v1/${endpoint}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': localStorage.getItem('token')
        }
      });
      const data = await response.json();
      console.log(`Fetched ${stateKey}:`, data);
      if (data[stateKey] || data.data || Array.isArray(data)) {
        setState(prev => ({
          ...prev,
          [stateKey]: data[stateKey] || data.data || data
        }));
      }
    } catch (error) {
      console.error(`Error fetching ${stateKey}:`, error);
    }
  };

  const handleAccountChange = (type, value) => {
    switch (type) {
      case 'repo-type':
        setSelectedRepoType(value);
        setSelectedRepoAccount('');
        break;
      case 'repo-account':
        if (value === 'add_new') {
          // TODO: Navigate to connected apps or open modal
          toast.info('Please configure this account in Connected Apps');
          return;
        }
        setSelectedRepoAccount(value);
        const selectedRepoAcc = state[selectedRepoType]?.find(
          acc => acc._id === value
        );
        if (selectedRepoAcc) {
          let repoConfig = {
            username: '',
            token: '',
            email: selectedRepoAcc.email || '',
            workspace: ''
          };

          if (selectedRepoType === 'github') {
            repoConfig.username = selectedRepoAcc.gitUsername || '';
            repoConfig.token = selectedRepoAcc.gitPat || '';
          } else if (selectedRepoType === 'gitlab') {
            repoConfig.username = selectedRepoAcc.gitUsername || '';
            repoConfig.token = selectedRepoAcc.gitlabPat || selectedRepoAcc.gitPat || '';
          } else if (selectedRepoType === 'bitbucket') {
            repoConfig.username = selectedRepoAcc.username || '';
            repoConfig.token = selectedRepoAcc.bitbucketToken || selectedRepoAcc.appPassword || '';
            repoConfig.workspace = selectedRepoAcc.workspace || '';
          }

          setSelectedRepoConfig(repoConfig);
          console.log('Repository credentials saved:', {
            platform: selectedRepoType,
            username: repoConfig.username,
            hasToken: !!repoConfig.token
          });
        }
        break;
      case 'devops-type':
        setSelectedDevOpsType(value);
        setSelectedDevOpsAccount('');
        break;
      case 'devops-account':
        if (value === 'add_new') {
          toast.info('Please configure this account in Connected Apps');
          return;
        }
        setSelectedDevOpsAccount(value);
        break;
      case 'cloudhub':
        if (value === 'add_new') {
          toast.info('Please configure this account in Connected Apps');
          return;
        }
        setSelectedCloudHubAccount(value);
        setSelectedEnvironment('');
        setSelectedEnvironmentId('');
        if (value) {
          fetchEnvironments(value);
        }
        break;
      default:
        break;
    }
  };

  // const fetchEnvironments = async (accountId) => {
  //   if (!accountId) return;
  //   setLoadingEnvironments(true);
  //   setEnvironmentError('');

  //   try {
  //     const token = localStorage.getItem('token');
  //     const response = await fetch(
  //       `${process.env.REACT_APP_BACKEND_URL}/api/v1/mule/environments}`,
  //       {
  //         headers: { 'Authorization': `Bearer ${token}` }
  //       }
  //     );

  //     if (!response.ok) throw new Error('Failed to fetch environments');

  //     const data = await response.json();
  //     setEnvironments(data.environments || data.data || []);
  //   } catch (error) {
  //     console.error('Error fetching environments:', error);
  //     setEnvironmentError(error.message || 'Failed to load environments');
  //     setEnvironments([]);
  //   } finally {
  //     setLoadingEnvironments(false);
  //   }
  // };

  const fetchEnvironments = async (accountId) => {
    if (!accountId) {
      setEnvironments([]);
      return;
    }

    setLoadingEnvironments(true);
    setEnvironmentError(null);
    setEnvironments([]);
    setSelectedEnvironment('');

    try {
      // Get the selected account's credentials
      const selectedMuleAccount = state.mule?.find(acc => acc._id === accountId);

      if (!selectedMuleAccount) {
        setEnvironmentError('Account not found');
        setLoadingEnvironments(false);
        return;
      }

      // Prepare credentials to send to backend
      const credentials = {
        connAppClientId: selectedMuleAccount.connAppClientId || '',
        connAppClientSecret: selectedMuleAccount.connAppClientSecret || '',
        muleClientId: selectedMuleAccount.muleClientId || '',
        muleClientSecret: selectedMuleAccount.muleClientSecret || '',
        muleOrgId: selectedMuleAccount.muleOrgId || ''
      };

      console.log("🔄 Fetching environments for account:", selectedMuleAccount.muleOrg);
      console.log("📍 URL:", domain + '/api/v1/mule/org/environments');

      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': localStorage.getItem('token')
        },
        body: JSON.stringify(credentials)
      };

      const response = await fetch(domain + '/api/v1/mule/org/environments', requestOptions);

      const result = await response.json();

      if (response.ok && result.success) {
        // ✅ Extract the 'data' array from the response
        const envList = result.data || [];
        setEnvironments(envList);
        console.log('✅ Environments loaded:', envList.length);
        console.log('📋 Environments:', envList);
      } else {
        setEnvironmentError(result.error || result.message || 'Failed to load environments');
        console.error('❌ Failed to load environments:', result);
      }
    } catch (error) {
      console.error('❌ Error fetching environments:', error);
      setEnvironmentError('Failed to connect to server');
    } finally {
      setLoadingEnvironments(false);
    }
  };

  const handleUnifiedDeploy = async () => {
    if (!selectedRepoAccount || !selectedDevOpsAccount || !selectedCloudHubAccount) {
      toast.error('Please configure all deployment platforms before deploying');
      return;
    }

    setIsDeploying(true);

    try {
      const token = sessionStorage.getItem('token');
      const deployPayload = {
        migrationId: state.migrationId,
        projectName: projName,
        repository: selectedRepoConfig,
        devops: {
          type: selectedDevOpsType,
          accountId: selectedDevOpsAccount
        },
        cloudhub: {
          accountId: selectedCloudHubAccount,
          environment: selectedEnvironment,
          environmentId: selectedEnvironmentId
        }
      };

      const response = await fetch(
        `${backendUrl}/api/v1/migration/deployment`,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(deployPayload)
        }
      );

      if (!response.ok) throw new Error('Deployment failed');

      const data = await response.json();
      toast.success('Deployment initiated successfully!');
      console.log('Deploy result:', data);

    } catch (error) {
      console.error('Deploy error:', error);
      toast.error(`Deployment failed: ${error.message}`);
    } finally {
      setIsDeploying(false);
    }
  };
  // useEffect(() => {
  //   if (logEndRef.current) {
  //     logEndRef.current.scrollIntoView({ behavior: 'smooth' });
  //   }
  // }, [state.logs]);



  useEffect(() => {
    if (onConfigChange && typeof onConfigChange === 'function') {
      onConfigChange(config);
    }
  }, [config, onConfigChange]);

  useEffect(() => {
    if (currentStep === 'deploy') {
      getResource('repo', 'github');
      getResource('gitlab', 'gitlab');
      getResource('bitbucket', 'bitbucket');
      getResource('mule', 'mule');
      getResource('azaccount', 'azaccount');
      getResource('jenkins', 'jenkins');
    }
  }, [currentStep]);

  useEffect(() => {
    return () => {
      if (state.pollInterval) {
        clearInterval(state.pollInterval);
      }
    };
  }, [state.pollInterval]);

  useEffect(() => {
    if (logContainerRef.current) {
      const container = logContainerRef.current;
      setTimeout(() => {
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      }, 50);
    }
  }, [state.logs]);

  useEffect(() => {
    const newSessionId = `intelog-session-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    console.log('Generated Session ID:', newSessionId);
    setSessionId(newSessionId);

    const socket = socketIOClient(socketUrl, {
      rejectUnauthorized: true,
      transports: ['websocket']   // websocket-only → no sticky sessions needed (K8s multi-pod)
    });

    socket.on("connect", () => {
      console.log('Socket connected:', socket.id);
      console.log('Joining session room:', newSessionId);
      socket.emit('join-session', newSessionId);

      setState(prev => ({
        ...prev,
        socketConnected: true,
        logs: [...prev.logs, {
          timestamp: new Date().toISOString(),
          level: 'info',
          message: `🔌 Connected to server (Socket ID: ${socket.id})`,
          type: 'system'
        }]
      }));
    });

    socket.on('joined-session', (data) => {
      console.log('Successfully joined session room:', data.sessionId);
      setState(prev => ({
        ...prev,
        logs: [...prev.logs, {
          timestamp: new Date().toISOString(),
          level: 'success',
          message: `Joined migration session: ${data.sessionId}`,
          type: 'system'
        }]
      }));
    });

    socket.on('migration:log', (response) => {
      console.log("📝 Migration log received:", response);

      if (!response || !response.message) {
        console.warn('⚠️ Invalid log format:', response);
        return;
      }

      const logEntry = {
        timestamp: response.timestamp || new Date().toISOString(),
        level: response.level || 'info',
        message: response.message,
        type: response.type || 'log',
        details: response.details
      };

      console.log(`[${logEntry.timestamp}] [${logEntry.level}]`, logEntry.message);
      setState(prev => ({
        ...prev,
        logs: [...prev.logs, logEntry]
      }));
    });

    socket.on('migration:progress', (progressData) => {
      console.log('Received progress:', progressData);
      setState(prev => ({
        ...prev,
        progress: progressData.percentage || 0,
        migrationProgress: {
          ...prev.migrationProgress,
          percentage: progressData.percentage || 0,
          current: progressData.current || 0,
          total: progressData.total || prev.migrationProgress.total,
          status: progressData.status
        }
      }));
    });

    socket.on('migration:file:start', (fileData) => {
      console.log('File started:', fileData);
      setState(prev => ({
        ...prev,
        logs: [...prev.logs, {
          timestamp: new Date().toISOString(),
          level: 'info',
          message: `📄 Processing: ${fileData.fileName}`,
          type: 'file',
          details: fileData
        }]
      }));
    });

    socket.on('migration:file:complete', (fileData) => {
      console.log('File completed:', fileData);
      const methodEmoji = fileData.migrationMethod === 'ai-powered' ? '🤖' : '📋';
      setState(prev => ({
        ...prev,
        logs: [...prev.logs, {
          timestamp: new Date().toISOString(),
          level: 'success',
          message: `✅ Completed: ${fileData.fileName} ${methodEmoji}`,
          type: 'file',
          details: fileData
        }]
      }));
    });

    socket.on('migration:file:error', (errorData) => {
      console.log('File error:', errorData);
      setState(prev => ({
        ...prev,
        logs: [...prev.logs, {
          timestamp: new Date().toISOString(),
          level: 'error',
          message: `Failed: ${errorData.fileName} - ${errorData.error}`,
          type: 'error',
          details: errorData
        }]
      }));
    });

    socket.on('migration:complete', (resultData) => {
      console.log('Migration complete:', resultData);
      setState(prev => ({
        ...prev,
        logs: [...prev.logs, {
          timestamp: new Date().toISOString(),
          level: 'success',
          message: `🎉 Migration completed! ${resultData.successCount || 0} successful, ${resultData.failureCount || 0} failed`,
          type: 'system'
        }]
      }));
    });

    socket.on('disconnect', (reason) => {
      console.log('❌ Socket disconnected:', reason);
      setState(prev => ({
        ...prev,
        socketConnected: false,
        logs: [...prev.logs, {
          timestamp: new Date().toISOString(),
          level: 'warning',
          message: `🔌 Disconnected from server: ${reason}`,
          type: 'system'
        }]
      }));
    });

    socket.on('connect_error', (error) => {
      console.error('❌ Socket connection error:', error);
      setState(prev => ({
        ...prev,
        logs: [...prev.logs, {
          timestamp: new Date().toISOString(),
          level: 'error',
          message: `Connection error: ${error.message}`,
          type: 'system'
        }]
      }));
    });

    if (socket.connected) {
      console.log('⚡ Socket already connected, joining room immediately');
      socket.emit('join-session', newSessionId);
    }

    socketRef.current = socket;

    return () => {
      if (socket) {
        console.log('🧹 Cleaning up socket connection');
        socket.off('migration:log');
        socket.off('migration:progress');
        socket.off('migration:file:start');
        socket.off('migration:file:complete');
        socket.off('migration:file:error');
        socket.off('migration:complete');
        socket.disconnect();
      }
    };
  }, []);


  const handleConfigChange = (path, value) => {
    console.log(`Config change: ${path} =`, value);
    if (path.includes('.')) {
      const keys = path.split('.');
      setConfig(prev => {
        const updated = { ...prev };
        let current = updated;
        for (let i = 0; i < keys.length - 1; i++) {
          if (!current[keys[i]]) current[keys[i]] = {};
          current = current[keys[i]];
        }
        current[keys[keys.length - 1]] = value;
        return updated;
      });
    } else {
      setConfig(prev => ({ ...prev, [path]: value }));
    }
  };



  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const files = Array.from(e.dataTransfer.files);
    if (files.length > 0) {
      handleFileSelect({ target: { files } });
    }
  };



  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };


  const handleFileSelect = (event) => {
    const files = Array.from(event.target.files);

    if (files.length === 0) return;

    setState(prev => ({ ...prev, loading: true }));

    const processedFiles = files.map(file => {
      const fileId = Date.now() + Math.random();

      filesRef.current.push({
        id: fileId,
        file: file
      });

      console.log('Storing file in ref:', file.name, file.size, file instanceof File);

      return {
        id: fileId,
        name: file.name,
        size: file.size,
        type: file.type,
        status: 'ready',
        preview: null
      };
    });

    const sourceInfo = migrationTypes.source[config.sourceType];
    const allowedTypes = sourceInfo.fileTypes;

    const validFiles = processedFiles.filter(file => {
      const extension = '.' + file.name.split('.').pop().toLowerCase();
      return allowedTypes.includes(extension) || file.name.toLowerCase().endsWith('.zip');
    });

    const invalidFiles = processedFiles.filter(file => {
      const extension = '.' + file.name.split('.').pop().toLowerCase();
      return !allowedTypes.includes(extension) && !file.name.toLowerCase().endsWith('.zip');
    });

    if (invalidFiles.length > 0) {
      toast.warn(`${invalidFiles.length} files were skipped due to unsupported file types`);
      const validIds = validFiles.map(f => f.id);
      filesRef.current = filesRef.current.filter(f => validIds.includes(f.id));
    }

    setState(prev => ({
      ...prev,
      uploadedFiles: [...prev.uploadedFiles, ...validFiles],
      loading: false,
      fileSelected: validFiles.length > 0
    }));

    if (validFiles.length > 0) {
      toast.success(`${validFiles.length} files uploaded successfully`);
    }

    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleStartMigration = async () => {
    if (state.uploadedFiles.length === 0) {
      toast.error('Please upload files for migration');
      return;
    }

    try {
      setState(prev => ({ ...prev, loading: true, migrationInProgress: true }));
      setCurrentStep('migrate');

      const formData = new FormData();

      console.log('=== DEBUG INFO ===');
      console.log('Files in state:', state.uploadedFiles);
      console.log('Files in ref:', filesRef.current);

      if (filesRef.current.length === 0) {
        console.error('ERROR: No files in filesRef!');
        toast.error('No files found. Please try uploading again.');
        setState(prev => ({ ...prev, loading: false, migrationInProgress: false }));
        return;
      }

      let filesAdded = 0;
      state.uploadedFiles.forEach((fileData, index) => {
        const fileRef = filesRef.current.find(f => f.id === fileData.id);
        console.log(`File ${index}:`, {
          fileData: fileData,
          fileRef: fileRef,
          hasFileObject: fileRef && fileRef.file instanceof File
        });

        if (fileRef && fileRef.file instanceof File) {
          console.log(`✓ Adding file: ${fileData.name} (${fileRef.file.size} bytes)`);
          formData.append('files', fileRef.file, fileData.name);
          filesAdded++;
        } else {
          console.error(`✗ Missing File object for: ${fileData.name}`);
        }
      });

      formData.append('projectName', projName);
      formData.append('sourceType', config.sourceType);
      formData.append('targetType', config.targetType);
      // Hardcoded strategy as 'standard'
      formData.append('migrationConfig', JSON.stringify({
        strategy: 'standard',
        outputFormat: config.outputFormat,
        optimizations: config.optimizations,
        advanced: config.advanced
      }));

      console.log(`Files added to FormData: ${filesAdded}`);

      console.log('FormData entries:');
      for (let [key, value] of formData.entries()) {
        if (value instanceof File) {
          console.log(`  ${key}: File(${value.name}, ${value.size} bytes, ${value.type})`);
        } else {
          console.log(`  ${key}: ${value}`);
        }
      }

      if (filesAdded === 0) {
        throw new Error('No valid files were added to the request');
      }

      console.log('Sending request to:', `${backendUrl}/api/v1/migration/start`);

      const response = await fetch(`${backendUrl}/api/v1/migration/start`, {
        method: 'POST',
        body: formData,
        headers: {
          'x-session-id': sessionId,
          'x-access-token': localStorage.getItem('token') || ''
        }
      });

      console.log('Response status:', response.status);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Response error:', errorText);
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      }

      const result = await response.json();
      console.log('Response result:', result);

      if (result.success) {
        const migrationId = result.migrationId || result.sessionId;

        if (!migrationId) {
          throw new Error('No migration ID received from server');
        }

        setState(prev => ({
          ...prev,
          migrationId: migrationId,
          migrationProgress: {
            percentage: 0,
            current: 0,
            total: state.uploadedFiles.length,
            status: 'started',
            results: [],
            errors: []
          }
        }));

        pollMigrationProgress(migrationId);
        toast.success('Migration started successfully!');

      } else {
        throw new Error(result.message || result.error || 'Migration failed to start');
      }

    } catch (error) {
      console.error('Migration failed:', error);
      setState(prev => ({
        ...prev,
        loading: false,
        migrationInProgress: false
      }));
      toast.error('Migration failed: ' + error.message);
    }
  };

  // Log Viewer Component
  // const LogViewer = () => {
  //   const getLogIcon = (level) => {
  //     switch (level) {
  //       case 'error': return '❌';
  //       case 'warning': return '⚠️';
  //       case 'success': return '✅';
  //       case 'info': return 'ℹ️';
  //       default: return '📝';
  //     }
  //   };

  //   const getLogColor = (level) => {
  //     switch (level) {
  //       case 'error': return '#ef4444';
  //       case 'warning': return '#f59e0b';
  //       case 'success': return '#10b981';
  //       case 'info': return '#3b82f6';
  //       default: return '#6b7280';
  //     }
  //   };

  //   const formatTimestamp = (timestamp) => {
  //     const date = new Date(timestamp);
  //     return date.toLocaleTimeString('en-US', {
  //       hour12: false,
  //       hour: '2-digit',
  //       minute: '2-digit',
  //       second: '2-digit',
  //       fractionalSecondDigits: 3
  //     });
  //   };

  //   return (
  //     <div className="log-viewer-container">
  //       <div className="log-viewer-header">
  //         <Terminal className="log-viewer-icon" />
  //         <h4>Migration Logs</h4>
  //         <div className="log-viewer-status">
  //           <div className={`status-indicator ${state.socketConnected ? 'connected' : 'disconnected'}`}></div>
  //           <span>{state.socketConnected ? 'Connected' : 'Disconnected'}</span>
  //         </div>
  //         {state.logs.length > 0 && (
  //           <button
  //             className="clear-logs-btn"
  //             onClick={() => setState(prev => ({ ...prev, logs: [] }))}
  //             title="Clear logs"
  //           >
  //             Clear
  //           </button>
  //         )}
  //       </div>
  //       <div className="log-viewer-content" ref={logContainerRef}>
  //         {state.logs.length === 0 ? (
  //           <div className="log-empty-state">
  //             <Terminal style={{ width: '3rem', height: '3rem', opacity: 0.3 }} />
  //             <p>Waiting for logs...</p>
  //           </div>
  //         ) : (
  //           state.logs.map((log, index) => (
  //             <div key={index} className="log-entry" data-level={log.level}>
  //               <span className="log-timestamp">{formatTimestamp(log.timestamp)}</span>
  //               <span className="log-icon">{getLogIcon(log.level)}</span>
  //               <span className="log-message" style={{ color: getLogColor(log.level) }}>
  //                 {log.message}
  //               </span>
  //               {log.details && (
  //                 <div className="log-details">
  //                   {JSON.stringify(log.details, null, 2)}
  //                 </div>
  //               )}
  //             </div>
  //           ))
  //         )}
  //          <div ref={logEndRef} />
  //       </div>
  //     </div>
  //   );
  // };

  function detectComponentTypeFromName(fileName) {
    if (!fileName) return 'unknown';

    const name = fileName.toLowerCase();

    if (name.includes('operation') || name.endsWith('.jop')) return 'operation';
    if (name.includes('transformation') || name.includes('transform') || name.endsWith('.jtr')) return 'transformation';
    if (name.includes('connector') || name.includes('connection')) return 'connector';
    if (name.includes('schema') || name.endsWith('.xsd')) return 'schema';
    if (name.includes('config') || name.endsWith('.properties')) return 'config';

    return 'other';
  }

  const pollMigrationProgress = (migrationId) => {
    console.log(`Starting to poll migration progress for ID: ${migrationId}`);

    const pollInterval = setInterval(async () => {
      try {
        console.log(`Polling migration status...`);

        const response = await fetch(`${backendUrl}/api/v1/migration/${migrationId}/status`, {
          method: 'GET',
          headers: {
            'x-access-token': localStorage.getItem('token') || ''
          }
        });

        if (!response.ok) {
          console.error(`Status check failed: ${response.status}`);
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log('Progress update:', data);

        if (data.success) {
          setState(prev => ({
            ...prev,
            progress: data.progress || 0,
            migrationStatus: data.status,
            migrationProgress: {
              percentage: data.progress || 0,
              current: data.processedFiles || 0,
              total: data.totalFiles || prev.migrationProgress?.total || 0,
              status: data.status,
              results: data.results || [],
              errors: data.errors || [],
              startTime: data.startedAt,
              endTime: data.completedAt
            }
          }));

          if (data.status === 'completed' || data.status === 'failed') {
            clearInterval(pollInterval);

            setState(prev => ({
              ...prev,
              loading: false,
              migrationInProgress: false,
              pollInterval: null
            }));

            if (data.status === 'completed') {
              console.log("FALL BACK RESULTS PROCESSING", data);
              clearInterval(pollInterval);
              setMigrationId(data.migrationId);
              setRamlFilePath(data.ramlGeneration.ramlFilePath);

              const breakdown = data.componentBreakdown || {};

              console.log('Migration completed, processing results:', data.results);

              const migratedFiles = [];

              if (data.results && Array.isArray(data.results)) {
                data.results.forEach((result, index) => {
                  console.log(`Processing result ${index}:`, result);

                  const originalName = result.fileName ||
                    result.name ||
                    result.originalName ||
                    result.file?.name ||
                    `file_${index + 1}`;

                  const convertedName = result.result?.convertedFile ||
                    result.convertedFile ||
                    result.outputFile ||
                    `converted_${originalName}`;

                  const fileSize = result.result?.size ||
                    result.size ||
                    result.file?.size ||
                    0;

                  const componentType = result.componentType ||
                    result.type ||
                    detectComponentTypeFromName(originalName);

                  migratedFiles.push({
                    original: originalName,
                    migrated: convertedName,
                    status: result.status === 'success' ? 'success' : 'failed',
                    size: fileSize,
                    componentType: componentType,
                    migrationMethod: result.migrationMethod || 'unknown',
                  });
                });
              }

              if (data.errors && Array.isArray(data.errors)) {
                data.errors.forEach((error, index) => {
                  const fileName = error.fileName || error.file?.name;

                  if (!fileName) {
                    console.warn(`⚠️ Skipping error entry without fileName at index ${index}:`, error);
                    return;
                  }

                  migratedFiles.push({
                    original: fileName,
                    migrated: `failed_${fileName}`,
                    status: 'failed',
                    size: error.size || error.file?.size || 0,
                    componentType: error.componentType || detectComponentTypeFromName(fileName),
                    error: error.error || error.message || 'Unknown error'
                  });
                });
              }

              const formattedResults = {
                migrationId: migrationId,
                totalFiles: breakdown.totalFiles || data.totalFiles || 0,
                successfulMigrations: breakdown.successfulComponents || 0,
                failedMigrations: breakdown.migrationMethods.failed || 0,
                operations: breakdown.operations || 0,
                transformations: breakdown.transformations || 0,
                otherComponents: breakdown.otherComponents || 0,
                totalBusinessComponents: breakdown.totalBusinessComponents || 0,
                aiPowered: breakdown.migrationMethods.aiPowered,
                templateBased: breakdown.migrationMethods.templateBased,
                methodsFailed: breakdown.migrationMethods.failed,
                totalComponents: breakdown.migrationMethods.total || 0,
                migratedFiles: migratedFiles
              };

              console.log('Final formatted results:', formattedResults);

              setState(prev => ({
                ...prev,
                migrationResults: formattedResults,
                loading: false,
                migrationInProgress: false
              }));

              toast.success(`Migration completed! Processed ${migratedFiles.length} files.`);
            } else if (data.status === 'failed') {
              toast.error('Migration failed. Check the results for details.');
              const errorMessages = data.errors?.map(err => err.error || err.general).join(', ') || 'Unknown error';
              console.error('Migration errors:', errorMessages);
            }
          }

        } else {
          throw new Error(data.error || 'Failed to get migration status');
        }

      } catch (error) {
        console.error('Error polling migration progress:', error);

        clearInterval(pollInterval);
        setState(prev => ({
          ...prev,
          loading: false,
          migrationInProgress: false,
          pollInterval: null
        }));

        toast.error('Lost connection to migration progress. Please refresh and check results.');
      }
    }, 500);

    setState(prev => ({ ...prev, pollInterval }));
  };

  useEffect(() => {
    return () => {
      if (state.pollInterval) {
        clearInterval(state.pollInterval);
      }
    };
  }, [state.pollInterval]);

  const downloadMigrationResults = async (migrationId) => {
    try {
      const response = await fetch(`${backendUrl}/api/v1/migration/${migrationId}/download-all`, {
        method: 'GET',
        headers: {
          'x-access-token': localStorage.getItem('token') || ''
        }
      });

      if (!response.ok) {
        throw new Error(`Download failed: ${response.status}`);
      }

      const blob = await response.blob();
      console.log('Received blob:', blob.size, 'bytes');
      const url = window.URL.createObjectURL(blob);

      const contentDisposition = response.headers.get('content-disposition');
      let filename = 'migration-results.zip';
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }

      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

      toast.success('Download started!');

    } catch (error) {
      console.error('Download error:', error);
      toast.error('Failed to download results: ' + error.message);
    }
  };

  const removeFile = (fileId) => {
    setState(prev => ({
      ...prev,
      uploadedFiles: prev.uploadedFiles.filter(f => f.id !== fileId)
    }));
    filesRef.current = filesRef.current.filter(f => f.id !== fileId);
  };

  const sourceInfo = migrationTypes.source[config.sourceType];
  const targetInfo = migrationTypes.target[config.targetType];

  // =============================================
  // STEP 1: File Upload Section
  // =============================================
  const renderFileUploadSection = () => (
    <div className="config-section">
      {/* <div className="migration-section-header">
        <Upload className="migration-card-icon" />
        <h2>Upload Files</h2>
      </div> */}

      <div className="migration-card">
        <div className="migration-card-header">
          <h3 className="migration-card-title">Select Source Type</h3>
        </div>
        <div className="source-type-grid">
          {Object.entries(migrationTypes.source).map(([key, info]) => (
            <label key={key}>
              <div className={`source-type-option ${config.sourceType === key ? 'selected' : ''}`}>
                <div className="source-type-header">
                  <input
                    type="radio"
                    name="sourceType"
                    value={key}
                    checked={config.sourceType === key}
                    onChange={(e) => handleConfigChange('sourceType', e.target.value)}
                    className="source-type-radio"
                  />
                  {info.icon}
                  <span className="source-type-name">{info.name}</span>
                </div>
                <p className="source-type-description">{info.description}</p>
                <div className="source-type-details">
                  Accepts: <span className="file-types">{info.fileTypes.join(', ')}</span>
                </div>
                {config.sourceType === key && (
                  <div className="source-type-details">
                    <div>Complexity: <span className="complexity">{info.complexity}</span></div>
                  </div>
                )}
              </div>
            </label>
          ))}
        </div>
      </div>

      <div className="migration-card">
        <div className="migration-card-header">
          <h3 className="migration-card-title">Upload {sourceInfo.name} Files</h3>
        </div>

        <div
          className="upload-zone"
          onDragOver={handleDragOver}
          onDrop={handleDrop}
          onClick={() => fileInputRef.current?.click()}
        >
          <Upload className="upload-icon" />
          <div className="upload-text">
            <strong>Click to upload</strong> or drag and drop
          </div>
          <div className="upload-subtext">
            Supported files: {sourceInfo.fileTypes.join(', ')}
          </div>
          <div className="upload-subtext">
            Maximum file size: 100MB per file
          </div>
        </div>

        <input
          ref={fileInputRef}
          type="file"
          multiple
          accept={sourceInfo.fileTypes.join(',')}
          onChange={handleFileSelect}
          style={{ display: 'none' }}
        />
      </div>

      {state.uploadedFiles.length > 0 && (
        <div className="migration-card">
          <div className="file-list-header">
            Uploaded Files ({state.uploadedFiles.length})
          </div>

          <div className="file-list">
            {state.uploadedFiles.map((file) => (
              <div key={file.id} className="file-item">
                <FileText className="file-icon" />
                <div className="file-info">
                  <div className="file-name">{file.name}</div>
                  <div className="file-meta">
                    {formatFileSize(file.size)} • {file.type || 'Unknown type'}
                  </div>
                </div>
                <div className="file-actions">
                  <button
                    onClick={() => removeFile(file.id)}
                    className="file-action-btn danger"
                    title="Remove file"
                  >
                    <X />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="migration-actions">
        <button
          onClick={() => navigate(-1)}
          className="migration-btn migration-btn-secondary"
          style={{ marginRight: '10px' }}
        >
          Cancel
        </button>
        <button
          onClick={handleStartMigration}
          disabled={state.uploadedFiles.length === 0 || state.loading}
          className="migration-btn migration-btn-primary"
        >
          {state.loading ? 'Starting Migration...' : 'Start Migration'}
        </button>
      </div>
    </div>
  );

  // =============================================
  // STEP 2: Migration Progress Section
  // =============================================
  const renderMigrationSection = () => (
    <div className="config-section">
      {state.migrationInProgress ? <div className="migration-section-header">
        <Zap className="migration-card-icon" />
        <h2 className="migration-card-title"> Migration in Progress</h2>
      </div> : null}

      {state.migrationInProgress && (
        <div className="migration-progress-container">
          <div className="progress-header">
            <div className="progress-spinner"></div>
            <span>
              {state.migrationProgress?.status === 'processing' ? 'Processing files...' : 'Starting migration...'}
            </span>
          </div>
          <div className="progress-bar-container">
            <div
              className="progress-bar"
              style={{ width: `${state.migrationProgress?.percentage || state.progress || 0}%` }}
            ></div>
          </div>
          <div className="progress-text">
            {state.migrationProgress?.percentage || state.progress || 0}% complete
            {state.migrationProgress?.current !== undefined && state.migrationProgress?.total !== undefined && (
              <span> ({state.migrationProgress.current}/{state.migrationProgress.total} files)</span>
            )}
          </div>

          <div className="log-viewer-container">
            <div className="log-viewer-header">
              <Terminal className="log-viewer-icon" />
              <h4>Migration Logs</h4>
              <div className="log-viewer-status">
                <div className={`status-indicator ${state.socketConnected ? 'connected' : 'disconnected'}`}></div>
                <span>{state.socketConnected ? 'Connected' : 'Disconnected'}</span>
              </div>
              {state.logs.length > 0 && (
                <button
                  className="clear-logs-btn"
                  onClick={() => setState(prev => ({ ...prev, logs: [] }))}
                  title="Clear logs"
                >
                  Clear
                </button>
              )}
            </div>
            <div className="log-viewer-content" ref={logContainerRef}>
              {state.logs.length === 0 ? (
                <div className="log-empty-state">
                  <Terminal style={{ width: '3rem', height: '3rem', opacity: 0.3 }} />
                  <p>Waiting for logs...</p>
                </div>
              ) : (
                state.logs.map((log, index) => (
                  <div key={index} className="log-entry" data-level={log.level}>
                    <span className="log-timestamp">
                      {new Date(log.timestamp).toLocaleTimeString('en-US', {
                        hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit', fractionalSecondDigits: 3
                      })}
                    </span>
                    <span className="log-icon">
                      {log.level === 'error' ? '❌' : log.level === 'warning' ? '⚠️' : log.level === 'success' ? '✅' : 'ℹ️'}
                    </span>
                    <span className="log-message" style={{
                      color: log.level === 'error' ? '#ef4444' : log.level === 'warning' ? '#f59e0b' : log.level === 'success' ? '#10b981' : '#3b82f6'
                    }}>
                      {log.message}
                    </span>
                    {log.details && (
                      <div className="log-details">{JSON.stringify(log.details, null, 2)}</div>
                    )}
                  </div>
                ))
              )}
              <div ref={logEndRef} />
            </div>
          </div>

          {/* <LogViewer /> */}

          {state.migrationProgress?.status && (
            <div className="migration-status">
              Status: <span className="status-badge">{state.migrationProgress.status}</span>
            </div>
          )}

          {state.migrationProgress?.results && state.migrationProgress.results.length > 0 && (
            <div className="migration-card" style={{ marginTop: '1rem' }}>
              <div className="migration-card-header">
                <h4>Processed Files</h4>
              </div>
              <div className="file-list">
                {state.migrationProgress.results.map((result, index) => (
                  <div key={index} className="file-item">
                    <FileText className="file-icon" />
                    <div className="file-info">
                      <div className="file-name">{result.fileName}</div>
                      <div className="file-meta">
                        {result.status === 'success' ? (
                          <span className="status-success">✓ Converted successfully</span>
                        ) : (
                          <span className="status-error">✗ Failed</span>
                        )}
                      </div>
                    </div>
                    <div className="file-actions">
                      {result.status === 'success' ? (
                        <CheckCircle className="result-status-icon success" />
                      ) : (
                        <AlertTriangle className="result-status-icon error" />
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {state.migrationProgress?.errors && state.migrationProgress.errors.length > 0 && (
            <div className="migration-card error-card" style={{ marginTop: '1rem' }}>
              <div className="migration-card-header">
                <h4>Errors</h4>
              </div>
              <div className="error-list">
                {state.migrationProgress.errors.map((error, index) => (
                  <div key={index} className="error-item">
                    <AlertTriangle className="error-icon" />
                    <div className="error-info">
                      <div className="error-file">{error.fileName || 'General Error'}</div>
                      <div className="error-message">{error.error || error.general}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}

      {/* Replace your entire {state.migrationResults && ( ... )} block with this */}

      {/* Replace your entire {state.migrationResults && ( ... )} block with this */}

      {state.migrationResults && (
        <>
          <div className="migration-dashboard">

            {/* Header */}
            <div className="migration-dashboard-header">
              <div className="dashboard-header-left">
                <Zap className="dashboard-header-icon" />
                <h2>Migration Results</h2>
              </div>
              <p className="dashboard-header-subtitle">
                {sourceInfo.name} to MuleSoft Migration Summary
              </p>
            </div>

            {/* Stats Cards */}
            <div className="dashboard-stats-grid">
              <div className="dashboard-stat-card stat-success">
                <div className="dashboard-stat-value">
                  {state.migrationResults.successfulMigrations || 0}
                </div>
                <div className="dashboard-stat-label">Components Migrated</div>
                <div className="dashboard-stat-description">Successfully converted</div>
              </div>

              <div className={`dashboard-stat-card ${(state.migrationResults.failedMigrations || 0) > 0 ? 'stat-error' : 'stat-success'}`}>
                <div className="dashboard-stat-value">
                  {state.migrationResults.failedMigrations || 0}
                </div>
                <div className="dashboard-stat-label">Failed Migrations</div>
                <div className="dashboard-stat-description">Require manual review</div>
              </div>

              <div className="dashboard-stat-card stat-neutral">
                <div className="dashboard-stat-value">
                  {(state.migrationResults.successfulMigrations || 0) + (state.migrationResults.failedMigrations || 0)}
                </div>
                <div className="dashboard-stat-label">Total Components</div>
                <div className="dashboard-stat-description">Business logic files</div>
              </div>

              <div className="dashboard-stat-card stat-info">
                <div className="dashboard-stat-value">
                  {state.migrationResults.totalFiles || 0}
                </div>
                <div className="dashboard-stat-label">Total Files Processed</div>
                <div className="dashboard-stat-description">Including config & schemas</div>
              </div>
            </div>

            {/* Two-Column: Analysis + Converted Files */}
            <div className="dashboard-analysis-grid">

              {/* LEFT: Component Analysis */}
              <div className="dashboard-analysis-panel">
                <h4 className="dashboard-panel-title">Component Analysis</h4>

                {/* Breakdown */}
                <div className="dashboard-breakdown">
                  <h5 className="dashboard-breakdown-title">Component Breakdown</h5>

                  <div className="dashboard-breakdown-row">
                    <span className="dashboard-breakdown-label">Successful Conversions</span>
                    <span className="dashboard-breakdown-value value-success">
                      {state.migrationResults.successfulMigrations || 0}
                    </span>
                  </div>

                  <div className="dashboard-breakdown-row">
                    <span className="dashboard-breakdown-label">Failed Conversions</span>
                    <span className="dashboard-breakdown-value value-error">
                      {state.migrationResults.failedMigrations || 0}
                    </span>
                  </div>

                  <div className="dashboard-breakdown-row breakdown-total">
                    <span className="dashboard-breakdown-label">Total Components</span>
                    <span className="dashboard-breakdown-value value-info">
                      {(state.migrationResults.successfulMigrations || 0) + (state.migrationResults.failedMigrations || 0)}
                    </span>
                  </div>
                </div>

                {/* Migration Methods */}
                {/* <div className="dashboard-methods-card">
                  <h5 className="dashboard-methods-title">Migration Methods</h5>

                  <div className="dashboard-method-row">
                    <div className="dashboard-method-label">
                      <span className="dashboard-method-dot dot-ai" />
                      <span className="dashboard-method-name">AI-Powered</span>
                    </div>
                    <span className="dashboard-method-count count-ai">
                      {state.migrationResults.aiPowered || 0}
                    </span>
                  </div>

                  <div className="dashboard-method-row">
                    <div className="dashboard-method-label">
                      <span className="dashboard-method-dot dot-template" />
                      <span className="dashboard-method-name">Template-Based</span>
                    </div>
                    <span className="dashboard-method-count count-template">
                      {state.migrationResults.templateBased || 0}
                    </span>
                  </div>

                  <div className="dashboard-method-row">
                    <div className="dashboard-method-label">
                      <span className="dashboard-method-dot dot-failed" />
                      <span className="dashboard-method-name">Failed</span>
                    </div>
                    <span className="dashboard-method-count count-failed">
                      {state.migrationResults.methodsFailed || 0}
                    </span>
                  </div>

                  {(() => {
                    const total = (state.migrationResults.aiPowered || 0) +
                      (state.migrationResults.templateBased || 0) +
                      (state.migrationResults.methodsFailed || 0);
                    if (total === 0) return null;
                    const aiPct = ((state.migrationResults.aiPowered || 0) / total) * 100;
                    const templatePct = ((state.migrationResults.templateBased || 0) / total) * 100;
                    const failedPct = ((state.migrationResults.methodsFailed || 0) / total) * 100;
                    return (
                      <div className="dashboard-methods-bar">
                        {aiPct > 0 && <div className="dashboard-methods-segment segment-ai" style={{ width: `${aiPct}%` }} />}
                        {templatePct > 0 && <div className="dashboard-methods-segment segment-template" style={{ width: `${templatePct}%` }} />}
                        {failedPct > 0 && <div className="dashboard-methods-segment segment-failed" style={{ width: `${failedPct}%` }} />}
                      </div>
                    );
                  })()}
                </div> */}
              </div>

              {/* RIGHT: Converted Files */}
              <div className="dashboard-files-panel">
                <div className="dashboard-files-header">
                  <h4>Converted Files</h4>
                  <span className="files-count-badge">
                    {state.migrationResults.migratedFiles?.length || 0} files
                  </span>
                </div>

                <div className="dashboard-files-list">
                  {state.migrationResults.migratedFiles && state.migrationResults.migratedFiles.length > 0 ? (
                    state.migrationResults.migratedFiles.map((file, index) => (
                      <div key={index} className="dashboard-file-item">
                        <FileText className="dashboard-file-icon" />
                        <div className="dashboard-file-info">
                          <div className="dashboard-file-name">
                            <span>{file.migrated || file.original}</span>
                            <span className={`dashboard-file-badge ${file.migrationMethod === 'ai-powered' ? 'badge-ai' : 'badge-template'}`}>
                              {file.migrationMethod === 'ai-powered' ? 'AI' : 'Template'}
                            </span>
                          </div>
                          <div className="dashboard-file-meta">
                            {file.original} → {formatFileSize(file.size)}
                          </div>
                        </div>
                        <div className="dashboard-file-status">
                          {file.status === 'success' ? (
                            <CheckCircle className="status-icon icon-success" />
                          ) : (
                            <AlertTriangle className="status-icon icon-error" />
                          )}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div style={{ textAlign: 'center', padding: '2rem', color: '#6b7280' }}>
                      <FileText style={{ width: '2rem', height: '2rem', margin: '0 auto 0.5rem', opacity: 0.4 }} />
                      <p style={{ margin: 0, fontSize: '0.875rem' }}>No converted files to display</p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Status Banner */}
            <div className={`dashboard-status-banner ${(state.migrationResults.failedMigrations || 0) === 0 ? 'banner-success' : 'banner-warning'}`}>
              {(state.migrationResults.failedMigrations || 0) === 0 ? (
                <CheckCircle className="dashboard-banner-icon icon-success" />
              ) : (
                <AlertTriangle className="dashboard-banner-icon icon-warning" />
              )}
              <div className="dashboard-banner-content">
                <p className="dashboard-banner-title">
                  {(state.migrationResults.failedMigrations || 0) === 0
                    ? 'Migration Successful!'
                    : 'Migration Finished with Issues'}
                </p>
                <p className="dashboard-banner-description">
                  {state.migrationResults.successfulMigrations || 0} components converted
                  {(state.migrationResults.failedMigrations || 0) > 0
                    ? `, ${state.migrationResults.failedMigrations} require manual review`
                    : ' successfully'}
                </p>
              </div>
            </div>

          </div>

          {/* Action Buttons - Download & Deploy */}
          <div className="migration-completion-section">
            <div className="completion-icon-container">
              {(state.migrationResults.failedMigrations || 0) === 0 ? (
                <CheckCircle className="completion-icon" />
              ) : (
                <AlertTriangle className="completion-icon" style={{ color: '#fbbf24' }} />
              )}
            </div>
            <h3 className="completion-title">
              {(state.migrationResults.failedMigrations || 0) === 0
                ? 'Migration Successful!'
                : 'Migration Finished with Issues'}
            </h3>
            <p className="completion-description">
              {(state.migrationResults.failedMigrations || 0) === 0
                ? 'All components have been successfully converted to MuleSoft. You can now download the artifacts or proceed to deployment.'
                : `${state.migrationResults.successfulMigrations || 0} components converted, ${state.migrationResults.failedMigrations} require manual review. You can still download and deploy the successful conversions.`}
            </p>
            <div className="completion-actions">
              <button
                className="migration-btn migration-btn-secondary"
                onClick={() => state.migrationId && downloadMigrationResults(state.migrationId)}
              >
                <Download style={{ width: '1rem', height: '1rem' }} />
                Download Artifacts
              </button>
              <button
                className="migration-btn migration-btn-secondary"
                onClick={() => {
                  setState(prev => ({ ...prev, migrationResults: null, uploadedFiles: [], progress: 0 }));
                  setCurrentStep('upload');
                  filesRef.current = [];
                }}
              >
                Start New Migration
              </button>
              <button
                className="migration-btn migration-btn-primary"
                onClick={() => setCurrentStep('deploy')}
              >
                <Rocket style={{ width: '1rem', height: '1rem' }} />
                Proceed to Deployment
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );

  // =============================================
  // STEP 3: Deployment Section (NEW)
  // =============================================

  // =============================================
  // STEP 3: Deployment Section
  // =============================================
  const renderDeploymentSection = () => (
    <div className="deploy-layout">

      {/* LEFT PANEL: Configuration */}
      <div className="deploy-config-panel">

        {/* Header */}
        <div className="deploy-panel-header">
          <div className="deploy-panel-header-left">
            <Rocket style={{ width: '1.25rem', height: '1.25rem' }} />
            <h3>Configure Deployment</h3>
          </div>
          <button
            onClick={() => setCurrentStep('migrate')}
            className="migration-btn migration-btn-secondary"
            style={{ fontSize: '0.8rem', padding: '0.375rem 0.75rem' }}
          >
            ← Back to Results
          </button>
        </div>

        {/* Scrollable Config Content */}
        <div className="deploy-config-content">

          {/* Repository Section */}
          <div className="deploy-section">
            <h5 className="deploy-section-title">
              <span className="deploy-section-icon">📦</span>
              Repository Configuration
            </h5>

            <div className="deploy-field-row">
              <div className="deploy-field-group">
                <label className="deploy-label">Select Platform:</label>
                <select
                  className="deploy-select"
                  value={selectedRepoType}
                  onChange={(e) => handleAccountChange('repo-type', e.target.value)}
                >
                  <option value="">-- Select Repository Platform --</option>
                  <option value="github">🐙 GitHub</option>
                  <option value="gitlab">🦊 GitLab</option>
                  <option value="bitbucket">🪣 Bitbucket</option>
                </select>
              </div>

              <div className="deploy-field-group">
                <label className="deploy-label">Select Account:</label>
                <select
                  className="deploy-select"
                  value={selectedRepoAccount}
                  onChange={(e) => handleAccountChange('repo-account', e.target.value)}
                  disabled={!selectedRepoType}
                >
                  {!selectedRepoType ? (
                    <option value="">-- Select platform first --</option>
                  ) : (
                    <>
                      <option value="">-- Select {selectedRepoType.charAt(0).toUpperCase() + selectedRepoType.slice(1)} Account --</option>
                      {state[selectedRepoType]?.map((account) => {
                        let displayName = '';
                        if (selectedRepoType === 'github') {
                          displayName = account.gitUsername ? `@${account.gitUsername}` : account.username;
                        } else if (selectedRepoType === 'bitbucket') {
                          displayName = account.workspace || account.username;
                        } else if (selectedRepoType === 'gitlab') {
                          displayName = account.gitUsername || account.username;
                        }
                        return (
                          <option key={account._id || account.id} value={account._id || account.id}>
                            {displayName}
                            {account.email && ` • ${account.email}`}
                          </option>
                        );
                      })}
                      <option value="add_new">+ Add New Account</option>
                    </>
                  )}
                </select>
                {selectedRepoAccount && selectedRepoAccount !== 'add_new' && (
                  <div className="deploy-badge-success">✓ Repository Configured</div>
                )}
              </div>
            </div>
          </div>

          {/* DevOps Section */}
          <div className="deploy-section">
            <h5 className="deploy-section-title">
              <span className="deploy-section-icon">🔧</span>
              DevOps Platform
            </h5>

            <div className="deploy-field-row">
              <div className="deploy-field-group">
                <label className="deploy-label">Select Platform:</label>
                <select
                  className="deploy-select"
                  value={selectedDevOpsType}
                  onChange={(e) => handleAccountChange('devops-type', e.target.value)}
                >
                  <option value="">-- Select DevOps Platform --</option>
                  <option value="azaccount">🔷 Azure DevOps</option>
                  <option value="github-actions">🐙 GitHub Actions</option>
                  <option value="gitlab-ci">🦊 GitLab CI/CD</option>
                  <option value="jenkins">⚙️ Jenkins</option>
                </select>
              </div>

              <div className="deploy-field-group">
                <label className="deploy-label">Select Configuration:</label>
                <select
                  className="deploy-select"
                  value={selectedDevOpsAccount}
                  onChange={(e) => handleAccountChange('devops-account', e.target.value)}
                  disabled={!selectedDevOpsType}
                >
                  {!selectedDevOpsType ? (
                    <option value="">-- Select platform first --</option>
                  ) : (
                    <>
                      <option value="">-- Select Configuration --</option>
                      {state[selectedDevOpsType]?.map((account) => {
                        let displayName = '';
                        if (selectedDevOpsType === 'azaccount') {
                          const orgMatch = account.organization?.match(/dev\.azure\.com\/(.+)/);
                          displayName = orgMatch ? orgMatch[1] : account.organization;
                        } else if (selectedDevOpsType === 'github-actions') {
                          displayName = account.repository || account.name;
                        } else if (selectedDevOpsType === 'gitlab-ci') {
                          displayName = account.project || account.name;
                        } else if (selectedDevOpsType === 'jenkins') {
                          displayName = account.server || account.name;
                        }
                        return (
                          <option key={account._id} value={account._id}>
                            {displayName}
                          </option>
                        );
                      })}
                      <option value="add_new">+ Add New Configuration</option>
                    </>
                  )}
                </select>
                {selectedDevOpsAccount && selectedDevOpsAccount !== 'add_new' && (
                  <div className="deploy-badge-success">✓ DevOps Configured</div>
                )}
              </div>
            </div>
          </div>

          {/* Anypoint Platform Section */}
          <div className="deploy-section">
            <h5 className="deploy-section-title">
              <span className="deploy-section-icon">☁️</span>
              Anypoint Platform
            </h5>

            <div className="deploy-field-row">
              <div className="deploy-field-group">
                <label className="deploy-label">Select Account:</label>
                <select
                  className="deploy-select"
                  value={selectedCloudHubAccount}
                  onChange={(e) => handleAccountChange('cloudhub', e.target.value)}
                >
                  <option value="">-- Select Anypoint Account --</option>
                  {state.mule?.map((account) => (
                    <option key={account._id} value={account._id}>
                      {account.muleOrg}
                    </option>
                  ))}
                  <option value="add_new">+ Add New Account</option>
                </select>
                {selectedCloudHubAccount && selectedCloudHubAccount !== 'add_new' && (
                  <div className="deploy-badge-success">✓ CloudHub Configured</div>
                )}
              </div>

              <div className="deploy-field-group">
                <label className="deploy-label">Select Environment:</label>
                <select
                  className="deploy-select"
                  value={selectedEnvironment}
                  onChange={(e) => {
                    const selectedEnvName = e.target.value;
                    const selectedEnv = environments.find(env => env.name === selectedEnvName);
                    setSelectedEnvironment(selectedEnvName);
                    setSelectedEnvironmentId(selectedEnv?.id || '');
                  }}
                  disabled={!selectedCloudHubAccount || selectedCloudHubAccount === 'add_new' || loadingEnvironments}
                >
                  <option value="">
                    {!selectedCloudHubAccount || selectedCloudHubAccount === 'add_new'
                      ? '-- Select account first --'
                      : loadingEnvironments
                        ? '⏳ Loading environments...'
                        : environments.length === 0 && !environmentError
                          ? '-- No environments available --'
                          : '-- Select Environment --'}
                  </option>
                  {environments.map((env) => (
                    <option key={env.id} value={env.name}>
                      {env.isProduction ? '🚀' : '🏖️'} {env.name} ({env.type})
                    </option>
                  ))}
                </select>

                {loadingEnvironments && (
                  <div className="deploy-loading">
                    <span className="progress-spinner" style={{ width: '0.875rem', height: '0.875rem' }} />
                    Fetching environments...
                  </div>
                )}

                {environmentError && !loadingEnvironments && (
                  <div className="deploy-error-msg">
                    ⚠️ {environmentError}
                    <button className="deploy-retry-btn" onClick={() => fetchEnvironments(selectedCloudHubAccount)}>
                      🔄 Retry
                    </button>
                  </div>
                )}

                {selectedEnvironment && !loadingEnvironments && (
                  <div className="deploy-badge-success">
                    ✓ Environment: {selectedEnvironment}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Deploy Actions */}
          <div className="deploy-actions-bar">
            <button
              className="migration-btn migration-btn-secondary"
              onClick={() => state.migrationId && downloadMigrationResults(state.migrationId)}
            >
              <Download style={{ width: '1rem', height: '1rem' }} />
              Download Artifacts
            </button>
            <button
              className="migration-btn migration-btn-primary"
              onClick={handleUnifiedDeploy}
              disabled={!selectedCloudHubAccount || !selectedRepoAccount || !selectedDevOpsAccount || isDeploying}
            >
              {isDeploying ? (
                <>
                  <span className="progress-spinner" style={{ width: '1rem', height: '1rem' }} />
                  Deploying...
                </>
              ) : (
                <>
                  <Rocket style={{ width: '1rem', height: '1rem' }} />
                  Deploy to All Platforms
                </>
              )}
            </button>
          </div>

        </div>
      </div>

      {/* RIGHT PANEL: Console */}
      {/* RIGHT PANEL: Console */}
      <div className="deploy-console-panel">
        <ConsolePromptPanel
          showPrompt={false}
          socketConnected={state.socketConnected}
          integrationLogs={state.logs}
          deploymentLogs={[]}
          onClearLogs={() => setState(prev => ({ ...prev, logs: [] }))}
        />
      </div>
      {/* <div className="deploy-console-panel">
        <div className="deploy-console-header">
          <div className="deploy-console-header-left">
            <Terminal style={{ width: '1.25rem', height: '1.25rem' }} />
            <h4>Console</h4>
          </div>
          <div className="deploy-console-status">
            <span className={`status-indicator ${state.socketConnected ? 'connected' : 'disconnected'}`} />
            <span>{state.socketConnected ? 'Connected' : 'Disconnected'}</span>
          </div>
        </div>

        <div className="deploy-console-content">
          {state.logs && state.logs.length > 0 ? (
            state.logs.map((log, index) => (
              <div key={index} className="deploy-console-entry" data-level={log.level}>
                <span className="deploy-console-time">
                  {new Date(log.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                </span>
                <span className="deploy-console-msg">{log.message}</span>
              </div>
            ))
          ) : (
            <div className="deploy-console-empty">
              <Terminal style={{ width: '2rem', height: '2rem', opacity: 0.3 }} />
              <p>Deployment logs will appear here</p>
            </div>
          )}
        </div>
      </div> */}

    </div>
  );

  const getCurrentStepContent = () => {
    switch (currentStep) {
      case 'upload':
        return renderFileUploadSection();
      case 'migrate':
        return renderMigrationSection();
      case 'deploy':
        return renderDeploymentSection();
      default:
        return renderFileUploadSection();
    }
  };

  return (
    <div className="root">
      <CustomHeader />
      <main className="content">
        <div className="project-overview-wrap">
          <Container className="project-overview-container">
            <Row className="project-container-row">
              <Col xs={12} className="projects-container">

                <div className="migration-steps">
                  <div className={`migration-step ${currentStep === 'upload' ? 'active' : ''}`}>
                    <div className="migration-step-number">1</div>
                    <span>Upload</span>
                  </div>
                  <ArrowRight className="migration-step-arrow" />
                  <div className={`migration-step ${currentStep === 'migrate' ? 'active' : ''}`}>
                    <div className="migration-step-number">2</div>
                    <span>Migrate</span>
                  </div>
                  <ArrowRight className="migration-step-arrow" />
                  <div className={`migration-step ${currentStep === 'deploy' ? 'active' : ''}`}>
                    <div className="migration-step-number">3</div>
                    <span>Deploy</span>
                  </div>
                </div>

                <div>
                  {getCurrentStepContent()}
                </div>

              </Col>
            </Row>
          </Container>
        </div>
      </main>
    </div>
  );
}

export default Migration;